import { DEFAULT_ANIMATE_DURATION, NextImage } from '@apeiron/temp'
import {
  styled,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material'
import LongSVG from '@public/icons/icon-long-skill-description.svg'
import ShortSVG from '@public/icons/icon-short-skill-description.svg'
import { useSkillContext } from '@src/contexts/skill/SkillContext'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const ButtonTab = styled(ToggleButtonGroup)`
  position: relative;
  height: 30px;
  border-radius: 4px;
  overflow: hidden;
`

const Button = styled(ToggleButton)`
  display: flex;
  gap: 6px;
  transition: ${DEFAULT_ANIMATE_DURATION}ms;
  position: relative;
  background-color: #757575;
  text-transform: none;
  width: 80px;
  ${props => props.theme.breakpoints.up('res1024')} {
    padding: 7px 12px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    padding: 7px 8px;
  }
  p,
  img {
    filter: invert(1) brightness(0.8);
    color: black;
    font-weight: 700;
    font-size: 12px;
  }
  :hover {
    background-color: #9d9d9d;
  }
  &.Mui-selected {
    background-color: #ffbf36;
    p,
    img {
      filter: unset;
      color: black;
      font-size: 12px;
    }
    :hover {
      background-color: #ffce63;
    }
  }
`

const Icon = styled(NextImage)`
  position: relative;
  height: 100%;
  aspect-ratio: 1;
`

const SkillDescriptionTab: FC<Props> = (props: Props) => {
  const { className } = props

  const { showDetail, setShowDetail } = useSkillContext()

  const { t } = useTranslation()

  const handleOnChange = useCallback(() => {
    setShowDetail(!showDetail)
  }, [showDetail, setShowDetail])

  return (
    <ButtonTab
      className={className}
      value={showDetail}
      exclusive
      onChange={handleOnChange}
    >
      <Button value={false}>
        <Icon src={ShortSVG} />
        <Typography>{t('common.button.short')}</Typography>
      </Button>
      <Button value>
        <Icon src={LongSVG} />
        <Typography>{t('common.button.long')}</Typography>
      </Button>
    </ButtonTab>
  )
}

type Props = {
  className?: string
}

export default SkillDescriptionTab
